import React, { useState } from "react";
import { Link } from "react-router-dom";
import { v4 as uuid } from "uuid";
import "../css/NewsSlider.css";
import { useInterval } from "../hooks/useInterval";
import LimitText from "./LimitText";
import { useSelector } from "react-redux";

const NewsSlider = ({ data, autoplay }) => {
  const [activeSlide, setActiveSlide] = useState(0);
  const [touched, setTouched] = useState(false);
  const { user } = useSelector((state) => state.auth);

  // Filter for newsletters user can access (public or matching their role)
  const accessibleData = data.filter(item => 
    item.attributes.role?.some(roleObj => 
      roleObj.Role === "Public" || (user && roleObj.Role === user.currentRole)
    )
  );

  const handleSlideChange = (val) => {
    let tmp = activeSlide + val;
    if (tmp > accessibleData.length - 1) {
      tmp = 0;
    } else if (tmp < 0) {
      tmp = accessibleData.length - 1;
    }
    setActiveSlide(tmp);
  };

  useInterval(() => {
    if (!touched) handleSlideChange(1);
  }, autoplay);

  return (
    <div className="r-slider" onClick={() => setTouched(true)}>
      <div className="r-slides">
        {accessibleData.map((el, i) => (
          <Slide 
            key={uuid()} 
            index={i} 
            data={el} 
            activeSlide={activeSlide} 
            handleSlideChange={handleSlideChange} 
          />
        ))}
      </div>
      <div className="r-slider__nav">
        {accessibleData.map((el, i) => (
          <span
            key={uuid()}
            className={`r-slider__navlink ${activeSlide === i ? "active" : null}`}
            onClick={() => {
              setTouched(true);
              setActiveSlide(i);
            }}
          ></span>
        ))}
      </div>
    </div>
  );
};

export default NewsSlider;

const Slide = ({ data, index, activeSlide }) => {
  return (
    <Link 
      to={`/newsletters/${data.id}`} 
      className={`r-slide ${activeSlide === index ? "active" : null}`}
    >
      <div className="r-slide-content">
        {data.attributes.photo && 
         data.attributes.photo.data && 
         data.attributes.photo.data.attributes && (
          <img src={data.attributes.photo.data.attributes.url} alt="" />
        )}
        <div className="r-right">
          <h3>{data.attributes.title}</h3>
          <p className="">{LimitText(data.attributes.body, 200)}</p>
        </div>
      </div>
    </Link>
  );
};